import { api } from './api'

export const linkGoogle = (idToken: string) =>
  api.post('google_user/link', {
    id_token: idToken,
  })
